import {Box, Button, ListItem} from '@mui/material';
import {Link, useLocation} from 'react-router-dom';
import React from 'react';

const styles = {
    item: {
        display: 'flex',
        paddingTop: 1,
        paddingBottom: 1,
        margin: '0 12px',
        width: 'calc(100% - 20px)',
    },
    icon: {
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        marginRight: 2,
        marginLeft: 1,
    },
    button: (theme: any) => ({
        color: '#66788A',
        padding: '10px 8px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%',
        fontWeight: theme.typography.fontWeightMedium,
        '&.active': {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
        },
        '&:first-child': {
            marginTop: 0,
        },
    }),
};

interface SideBarItemProps {
    url: string;
    label: string;
    icon: any;
    dimmed?: boolean;
}

const SideBarItem = (props: SideBarItemProps) => {
    const location = useLocation();

    return (
        <Box>
            <ListItem disableGutters={true} sx={styles.item}>
                <Button
                    sx={[
                        styles.button,
                        props.dimmed ? { opacity: 0.4, backgroundColor: '#f5f5f5' } : {},
                    ]}
                    className={location.pathname.startsWith(props.url) ? 'active' : ''}
                    children={(<>
                        <Box sx={styles.icon}>{props.icon}</Box>
                        {props.label}
                    </>)}
                    component={Link}
                    to={props.url}
                />
            </ListItem>
        </Box>
    );
};

export default SideBarItem;
